// import * as React from 'react';
import axios from 'axios';
import { GET_ERRORS, GET_CLIENTS_LIST } from './types';
const api_url = process.env.REACT_APP_API_URL;


export const addClient = (client, history) => dispatch => {
    axios.post(api_url+'clients/add', client)
            .catch(err => {
                dispatch({
                    type: GET_ERRORS,
                    payload: err.response.data
                });
            });
}

export const listClients = (currentorg, sort) => dispatch => {
    console.log('FIred');
  axios.get(
    api_url+'clients/list',
    { params: { organization: currentorg } }
  )
  .then(response => {
      let d = response.data;
      let s = null;
      switch (sort) {
        case 'email':
          s = d.sort((a, b) => a.email.localeCompare(b.email));
          break;
        default:
          s = d.sort((a, b) => a.name.localeCompare(b.name));

      }
      dispatch({
          type: GET_CLIENTS_LIST,
          payload: response.data
      });
  });
}
